import React from "react";
import { getCampaignStatusPresentation } from "../../utils/campaignDisplayUtils";

const STATUS_STYLES = {
    active: "border-emerald-200 bg-emerald-50 text-emerald-700",
    running: "border-emerald-200 bg-emerald-50 text-emerald-700",
    completed: "border-blue-200 bg-blue-50 text-blue-700",
    completedWithFailures: "border-amber-200 bg-amber-50 text-amber-800",
    preparing: "border-amber-200 bg-amber-50 text-amber-700",
    processing: "border-amber-200 bg-amber-50 text-amber-700",
    paused: "border-gray-200 bg-gray-100 text-gray-700",
    infraPaused: "border-amber-200 bg-amber-50 text-amber-800",
    failed: "border-red-200 bg-red-50 text-red-700",
    unknown: "border-gray-200 bg-gray-50 text-gray-600",
};

const CampaignStatusBadge = ({ status, campaign, isPaused }) => {
    const { label, styleKey } = getCampaignStatusPresentation(
        campaign || status,
        isPaused,
    );
    const className = STATUS_STYLES[styleKey] || STATUS_STYLES.unknown;

    return (
        <span
            title="Status of campaign"
            className={`inline-flex w-fit shrink-0 items-center whitespace-nowrap rounded-full border px-3 py-1.5 text-xs font-semibold leading-none ${className}`}
        >
            {label}
        </span>
    );
};

export default CampaignStatusBadge;
